import React, { Component } from 'react';
import { FaIcon } from '../FaIcon';
import { DataExplorerColumnsModal } from './DataExplorerColumnsModal';
import { FieldsSetsList } from './FieldsSetsList';
import { Spinner } from '../Spinner';
import { withTranslation } from 'react-i18next';

class FieldsSetsWidgetComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            creatingNewSet: false, // Flag para indicar si se está creando un nuevo set
        };
        this.closeModal = this.closeModal.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCreateNewSet = this.handleCreateNewSet.bind(this);
        this.handleConfigureColumns = this.handleConfigureColumns.bind(this);
    }

    closeModal() {
        this.setState({
            modal: false,
            creatingNewSet: false
        });
    }

    handleClick(event) {
        event.preventDefault();
        // No hacer nada aquí, el popover se mostrará con hover
        // Este handler se usa para el botón dentro del popover
    }
    
    handleConfigureColumns(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            modal: true,
            creatingNewSet: false
        });
    }

    renderModal() {
        if (this.state.modal) {
            // Si se está creando un nuevo set, pasar null como editingFieldsSet
            const editingFieldsSet = this.state.creatingNewSet ? null : this.props.editingFieldsSet;
            
            return (
                <DataExplorerColumnsModal
                    isOpen={this.state.modal}
                    toggle={this.closeModal}
                    onApply={this.props.onColumnsApply}
                    dimensions={this.props.dimensions}
                    metrics={this.props.metrics}
                    fieldsData={this.props.fieldsData}
                    sourceType={this.props.sourceType}
                    fieldsSets={this.props.fieldsSets}
                    editingFieldsSet={editingFieldsSet}
                    onFieldsSetSaved={this.props.onFieldsSetSaved}
                />
            );
        } else {
            return null;
        }
    }

    renderSavedSets() {
        const { t, fieldsSets, dimensions, metrics, fieldsData, loadingFieldsSets } = this.props;
        
        if (loadingFieldsSets) {
            return (
                <div style={{ padding: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Spinner />
                </div>
            );
        }
        
        if (!fieldsSets || fieldsSets.length === 0) {
            return null;
        }
        return [
            <p key={0} className="header-menu-title">{t('fields_sets_widget.saved_fields_sets', 'Sets de columnas guardados')}</p>,
            <FieldsSetsList 
                key={1} 
                fieldsSets={fieldsSets}
                dimensions={dimensions}
                metrics={metrics}
                fieldsData={fieldsData}
                editingFieldsSet={this.props.editingFieldsSet}
                onSelectFieldsSet={this.props.onSelectFieldsSet}
                onDeleteFieldsSet={this.props.onDeleteFieldsSet}
            />
        ];
    }

    getButtonText() {
        const { t, editingFieldsSet, dimensions, metrics } = this.props;
        
        // Si hay un set seleccionado, mostrar "Columnas: [nombre set]"
        if (editingFieldsSet && editingFieldsSet.name) {
            return `${t('config_columns_widget.columns')}: ${editingFieldsSet.name}`;
        }
        
        // Si hay columnas seleccionadas pero no hay un set asociado, mostrar "Columnas (N)"
        if ((dimensions && dimensions.length > 0) || (metrics && metrics.length > 0)) {
            const totalColumns = (dimensions?.length || 0) + (metrics?.length || 0);
            return `${t('config_columns_widget.columns', 'Columnas')} (${totalColumns})`;
        }
        
        // Si no hay columnas seleccionadas, mostrar "Elegir columnas"
        return t('data_explorer.choose_columns', 'Elegir columnas');
    }

    handleCreateNewSet(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            modal: true,
            creatingNewSet: true // Indicar que se está creando un nuevo set
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="columns-button-wrapper -wtih-menu" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                    className="btn -primary columns-button"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={this.handleConfigureColumns}
                >
                    <FaIcon iconName="columns" style={{ marginRight: '0.5rem' }} />
                    {this.getButtonText()}
                </button>
                <div className="dashboard-header-menu">
                    <button className="header-menu-button" onClick={this.handleConfigureColumns}>
                        <FaIcon iconName="cog"/>
                        {t('data_explorer.configure_columns', 'Configurar columnas')}
                    </button>
                    {this.renderSavedSets()}
                    <button className="header-menu-button -create-new" onClick={this.handleCreateNewSet}>
                        <FaIcon iconName="plus"/>
                        {t('data_explorer.create_new_fields_set', 'Crear nuevo set')}
                    </button>
                </div>
                {this.renderModal()}
            </div>
        );
    }
}

export const FieldsSetsWidget = withTranslation()(FieldsSetsWidgetComponent);
export default FieldsSetsWidget;

